module.exports = __webpack_public_path__ + "static/logo-crowder-e85ab69c66594655301fdf2c58d3c8c2.png";